var _polygon, _line, _line2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconMenuExcludedWords = function SvgIconMenuExcludedWords(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-x-octagon"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  })));
};

export default __webpack_public_path__ + "static/media/icon_menu_excluded_words.fc41af9d.svg";
export { SvgIconMenuExcludedWords as ReactComponent };